import React from 'react';
// @ts-ignore
import * as d3 from 'd3';
import styled from 'styled-components';

import { MARGIN } from './LineChart';

interface HorizontalAxisProps {
  xScale: d3.ScaleLinear<number, number>,
  chartHeight: number,
};

const HorizontalAxisLabel = styled.text`
  fill: white;
  font-family: Mapfre-Bold;
  font-size: 1.25rem;
  text-anchor: start;
  stroke-width: 10px;
`;

const VerticalTicker = styled.line`
  stroke: #F7F4F3;
  stroke-width: 3px;
  stroke-opacity: 0.25;
`;

const HorizontalAxis = ({ xScale, chartHeight }: HorizontalAxisProps) => {
  const ticks = xScale.nice().ticks(5);
  const fontSize = 40;

  return (
    <g>
      { ticks.map((value, i) => (
          <g key={`horizontal-tick-${i}`}>
            <HorizontalAxisLabel
              style={{
                transform: `translate(${xScale(value) - 25}px, ${MARGIN.top + chartHeight + fontSize})`
              }}
              transform={ `translate(${xScale(value) - 25} ${MARGIN.top + chartHeight + fontSize})` }
            >
              {value}
            </HorizontalAxisLabel>
            <VerticalTicker
              x1={ xScale(value) }
              x2={ xScale(value) }
              y1={ MARGIN.top }
              y2={ MARGIN.top + chartHeight }
            />
          </g>
        ))
      }
    </g>
  );
};

export default HorizontalAxis;
